import type { ConfigType } from 'dayjs'

import { appSelectors } from '@appStore/reducers/app'
import { createSelector } from '@reduxjs/toolkit'
import { appDay } from 'shared/day'

const addInUtc = (input: ConfigType, minutes: number) =>
	appDay(input).utc().add(minutes, 'minutes')

const selectNowWithOffset = createSelector(
	appSelectors.timezoneOffset,
	offset => addInUtc(Date.now(), offset ?? 0)
)

const selectCurrentDay = createSelector(selectNowWithOffset, now => ({
	start: now.startOf('day').toISOString(),
	// eslint-disable-next-line perfectionist/sort-objects
	end: now.endOf('day').toISOString()
}))

export { selectCurrentDay, selectNowWithOffset }
